import { useFormContext } from "react-hook-form";
import { Input } from "@/components/ui/input";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { BidFormValues } from "./types";
import { PositionData } from "./BidPositionsSection";

interface PositionFieldsProps {
  positions: PositionData[];
}

export function PositionFields({ positions }: PositionFieldsProps) {
  const { control, watch } = useFormContext<BidFormValues>();
  const positionValues = watch("positions") || {};
  const eventLength = watch("eventLength") || 0;
  const additionalFees = watch("additionalFee") || 0;
  const discountAmount = watch("discountAmount") || 0;

  const calculateTotal = () => {
    const positionCost = positions.reduce((total, position) => {
      const quantity = positionValues[position.id]?.quantity || 0;
      return (
        total + quantity * Number(position.billPrice) * Number(eventLength)
      );
    }, 0);
    return positionCost + (additionalFees - discountAmount);
  };

  return (
    <div className="space-y-4">
      {positions.map((position) => (
        <FormField
          key={position.id}
          control={control}
          name={`positions.${position.id}.quantity`}
          render={({ field }) => (
            <FormItem>
              <FormLabel>{position.tableName}</FormLabel>
              <FormControl>
                <Input
                  type="number"
                  min="0"
                  {...field}
                  defaultValue={position.quantity || 0}
                  onChange={(e) =>
                    field.onChange(parseInt(e.target.value) || 0)
                  }
                  placeholder={`Quantity for ${position.tableName}`}
                />
              </FormControl>
              <FormMessage />
            </FormItem>
          )}
        />
      ))}
      <div className="mt-4 text-lg font-semibold">
        Total: ${calculateTotal().toFixed(2)}
      </div>
    </div>
  );
}
